/* eslint-disable react/prop-types */
import { FaRegPenToSquare, FaTrash } from "react-icons/fa6";
import Moveable, { DIRECTIONS} from "react-moveable";

function DraggAbleComponentEdit({data, setTableStyle, setEdit, removeTable}) {
    // console.log(data)
  return (
    <div>
        <div id={data?.id} className="w-[200px] h-[200px] absolute flex flex-col gap-10 items-center justify-center" style={data?.style} >
            <div className=" text-2xl">
                {data?.name}
            </div>
            <div className=" text-2xl flex gap-4">
                <button onClick={()=>setEdit(data)} className=" text-color10"><FaRegPenToSquare/></button>
                <button onClick={()=> removeTable(data?.id)} className=" text-color8"><FaTrash/></button>
            </div>
        </div>
        <Moveable
            target={`#${data?.id}`}
            draggable={true}
            roundable={true}
            rotatable={{
                        renderDirections: DIRECTIONS,
                    }}
            resolveAblesWithRotatable={{
                resizable: ["nw", "ne", "sw", "se", "n", "e", "s"],
            }}
            resizable={{
                renderDirections: true,
            }}

            rotateAroundControls={true}
            isDisplayShadowRoundControls={"horizontal"}
            roundClickable={"control"}
            roundPadding={15}
            onRender={e => {
                e.target.style.cssText += e.cssText;
                // console.log(e.style)
               setTableStyle(e.target.id, {...e.style})
            }}
            onRenderEnd={e => {
                e.target.style.cssText += e.cssText;
            }}
        />
    </div>
  );
}

export default DraggAbleComponentEdit;